import React from 'react';
import { Mail } from 'lucide-react';
export function StickyBar() {
  return <div className="sticky top-0 z-50 bg-[#4DBFB8] text-white py-3 shadow-md" data-id="element-203">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-204">
        <div className="flex items-center justify-center gap-2 text-sm sm:text-base" data-id="element-205">
          <Mail className="w-4 h-4 flex-shrink-0" data-id="element-206" />
          <p className="font-medium text-center" data-id="element-207">
            Vragen over voeding of hulp bij bestellen? Email mij op:{' '}
            <a href="mailto:amee@stresslessdogs.nl" className="underline hover:text-white/90 transition-colors font-bold" data-id="element-208">
              amee@stresslessdogs.nl
            </a>
          </p>
        </div>
      </div>
    </div>;
}